import { TranslationObject } from '../../i18n/translation';

const translations: TranslationObject = {
  manglerTilganger: {
    id: 'institusjon.manglerTilganger',
    nb: '(mangler tilganger)',
    en: '(no access)',
  },
};

export default translations;
